module.exports = __webpack_public_path__ + "media/images/emblems/Albula-Alvra_Wappen-13104e62c92ec8f2e750a8785e349138.svg";